/**
 * Numeric limits shared between frontend and backend.
 * Keep these in sync with PRD §12 (security) and §13 (config).
 */
// Voice notes — Whisper API single-call cap is 25 MB.
export const VOICE_MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024;
export const VOICE_DEFAULT_MAX_DURATION_SECONDS = 300; // 5 min
// Generic upload bounds (per-agent override in `agents.max_upload_size_mb`)
export const UPLOAD_MIN_SIZE_MB = 1;
export const UPLOAD_MAX_SIZE_MB = 1024;
export const UPLOAD_DEFAULT_SIZE_MB = 100;
// LLM bounds
export const LLM_MIN_TOKENS = 1;
export const LLM_MAX_TOKENS = 8192;
export const LLM_DEFAULT_TOKENS = 2048;
export const LLM_MIN_TEMPERATURE = 0;
export const LLM_MAX_TEMPERATURE = 2;
export const LLM_DEFAULT_TEMPERATURE = 0.7;
// Field length bounds
export const AGENT_NAME_MAX = 80;
export const AGENT_DESCRIPTION_MAX = 500;
export const AGENT_SYSTEM_PROMPT_MAX = 20_000;
export const SHEET_NAME_MAX = 80;
export const SHEET_DESCRIPTION_MAX = 500;
export const USER_DISPLAY_NAME_MAX = 80;
// Token / secret bounds
export const CALLBACK_TOKEN_MIN = 16;
// Rate limits (window: 1 minute) — informational; enforced server-side
export const RATE_LIMIT_LOGIN_PER_MIN = 10;
export const RATE_LIMIT_MESSAGE_PER_MIN = 60;
export const RATE_LIMIT_VOICE_PER_MIN = 20;
export const RATE_LIMIT_ATTACHMENT_PER_MIN = 30;
export const RATE_LIMIT_ADMIN_PER_MIN = 30;
// Workflow timeouts
export const WORKFLOW_DISPATCH_ACCEPT_TIMEOUT_MS = 10_000;
export const WORKFLOW_CALLBACK_DEFAULT_TIMEOUT_MS = 15 * 60 * 1000; // 15 min
//# sourceMappingURL=limits.js.map